import { DomainError } from "@szerviz/core";
import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { ErrorText } from "../components/ErrorText";
import type { AuthIntent, DataStore } from "../data";

/** New password after an invitation or a reset link; also used in Settings to change it. */
export function PasswordForm({ store, onDone, compact }: { store: DataStore; onDone?: () => void; compact?: boolean }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [saved, setSaved] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSaved(false);
    try {
      if (password !== again) throw new DomainError("PASSWORDS_DIFFER");
      await store.setPassword(password);
      setSaved(true);
      setPassword("");
      setAgain("");
      onDone?.();
    } catch (err) {
      setError(err);
    }
  };
  return (
    <form className={compact ? "form-grid" : undefined} onSubmit={submit} noValidate>
      <label className="field">
        <span>{t("auth.newPassword")}</span>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} aria-label={t("auth.newPassword")} autoComplete="new-password" />
        <small>{t("auth.passwordHint")}</small>
      </label>
      <label className="field">
        <span>{t("auth.newPasswordAgain")}</span>
        <input type="password" value={again} onChange={(e) => setAgain(e.target.value)} aria-label={t("auth.newPasswordAgain")} autoComplete="new-password" />
      </label>
      <div className="actions wide">
        <ErrorText error={error} />
        {saved && <span className="ok">{t("auth.passwordSaved")}</span>}
        <button type="submit" className="primary">{t("auth.savePassword")}</button>
      </div>
    </form>
  );
}

export function SetPassword({ store, intent, onDone }: { store: DataStore; intent: AuthIntent; onDone: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="login">
      <div className="login-card">
        <h1>{t(intent === "invite" ? "auth.welcomeInvited" : "auth.title.reset")}</h1>
        <p>{t(intent === "invite" ? "auth.setPasswordInvite" : "auth.setPasswordRecovery")}</p>
        <PasswordForm store={store} onDone={onDone} />
      </div>
    </div>
  );
}
